var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 13.3333L17.5 10M17.5 10L14.1667 6.66668M17.5 10H5.83333M10.8333 13.3333V14.1667C10.8333 14.8297 10.5699 15.4656 10.1011 15.9344C9.63226 16.4033 8.99637 16.6667 8.33333 16.6667H5C4.33696 16.6667 3.70107 16.4033 3.23223 15.9344C2.76339 15.4656 2.5 14.8297 2.5 14.1667V5.83334C2.5 5.1703 2.76339 4.53442 3.23223 4.06558C3.70107 3.59674 4.33696 3.33334 5 3.33334H8.33333C8.99637 3.33334 9.63226 3.59674 10.1011 4.06558C10.5699 4.53442 10.8333 5.1703 10.8333 5.83334V6.66668",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogout);
export default __webpack_public_path__ + "static/media/sidebar-logout.bf07facdf901a38019ac183bcbf4c730.svg";
export { ForwardRef as ReactComponent };